import Panzoom from '@panzoom/panzoom'

function setup () {
  const container = document.body.querySelector('#lightbox')
  const img = container.querySelector('img')

  const panzoom = Panzoom(img, {
    maxScale: 4
  })

  if (container.querySelector('#lightbox--zoom-in')) {
    container.querySelector('#lightbox--zoom-in').addEventListener('click', () => panzoom.zoomIn())
  }

  if (container.querySelector('#lightbox--zoom-out')) {
    container.querySelector('#lightbox--zoom-out').addEventListener('click', () => panzoom.zoomOut())
  }

  img.addEventListener('panzoomzoom', event => {
    img.sizes = `${Math.floor(container.offsetWidth * event.detail.scale)}px`
  })

  if (container.querySelector('#lightbox--close')) {
    container.querySelector('#lightbox--close').addEventListener('click', () => close())
  }

  document.addEventListener('keydown', event => {
    event.key === 'Escape' && container.classList.contains('open') && close()
  })

  const images = [...document.querySelectorAll('img.lightbox')]
  images.forEach(image => image.addEventListener('click', event => launch(event)))

  function launch (event) {
    const target = event.target

    img.src = target.src
    img.dataset.srcset = target.srcset + `, ${target.dataset.full} 3840w`

    img.dataset.sizes = 'auto'
    img.alt = target.alt
    img.sizes = '100vw'
    img.classList.add('lazyload')

    img.classList.add(target.dataset.aspect <= 1 ? 'portrait' : 'landscape')

    container.classList.add('open')
  }

  function close () {
    container.classList.remove('open')
    panzoom.reset({ animate: false })

    img.src = ''
    img.srcset = ''
    img.dataset.srcset = ''
    img.dataset.set = ''
    img.alt = ''
    img.sizes = '100vw'
    img.className = ''
    img.classList.add('lazyload')
  }
}

document.addEventListener('turbo:load', function () {
  if (document.querySelector('#lightbox')) setup()
})
